import { Box, LinearProgress } from "@mui/material";
import BasicTable from "components/common/Table";
import Typography from "components/common/Typography";
import moment from "moment";
import { Link } from "react-router-dom";
import { tokens } from "styles/Tokens";
import { messages } from "utils/CommonConstants";
import { getMoreValues, getOwnerNames, getPropertyName, getSourceName } from "utils/CommonFunctions";
import { getUIFormatDate } from "utils/DateHelper";
import { getPlanDetailsRoute, getRoleCategory } from "utils/StoreUtils";
import { headers } from "./TableHeadersConfig";

interface Props {
  data: any;
  totalList: number;
  pagination: {};
}

function PlansProgress(props: Props) {
  const { data: plansList, totalList, pagination } = props;

  const getDateColor = (date: any, status: string) => {
    const todaysDate = moment().format("YYYY-MM-DD");
    return moment(date).isBefore(todaysDate) && status !== "Completed"
      ? tokens.Text.Feedback.Alert
      : tokens.Text.General.PrimaryHeadline;
  };
  return (
    <BasicTable
      id="tableDiv"
      totalRecords={totalList}
      pagination={pagination}
      noDataMessage={messages.noPropertyPlans}
      data={{
        headers,
        rows: plansList?.map((element: any) => {
          const progressVal = element?.cardsCompleted / element?.totalCards;
          const route = getPlanDetailsRoute();
          return {
            data: [
              {
                content: (
                  <Box
                    component={Link}
                    to={`/${route}/${element?.id}`}
                    sx={{
                      textDecoration: "none",
                      color: tokens.Text.General.PrimaryHeadline,
                      fontWeight: "700"
                    }}
                  >
                    {getPropertyName(element?.innCode) ?? element?.innCode}
                  </Box>
                )
              },
              { content: element?.innCode },
              {
                content: getMoreValues(getOwnerNames(element?.owners)),
                tooltip: {
                  title: "Owners",
                  list: getOwnerNames(element?.owners)?.map((owner: any) => {
                    return { name: owner };
                  })
                }
              },
              { content: getSourceName(element?.planSource) },
              { content: getRoleCategory(element?.owners) ?? "-" },
              {
                content: (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start"
                    }}
                  >
                    <Typography showBold variant="label" color={tokens.Text.General.Tertiary}>
                      {element?.status}
                    </Typography>
                    <LinearProgress
                      sx={{ width: "80px", height: "2px" }}
                      variant="determinate"
                      value={!isNaN(progressVal) ? progressVal * 100 : 0}
                    />
                    <Typography variant="label" color={tokens.Text.General.Tertiary}>
                      {" "}
                      {`${element?.cardsCompleted?.toString()}/${element?.totalCards?.toString()} done`}
                    </Typography>
                  </Box>
                )
              },
              {
                content: getUIFormatDate(element?.brandDeadlineDate),
                color: moment(element?.brandDeadlineDate).isBefore(new Date()) ? tokens.Text.Feedback.Alert : ""
              },
              {
                content: `${getUIFormatDate(element?.dueDate)}`,
                color: getDateColor(element?.dueDate, element?.status)
              }
            ]
          };
        })
      }}
    />
  );
}

export default PlansProgress;
